import BaseAPI from './base'

class SchoolExamPeriodRepairAPI extends BaseAPI {}

export default new SchoolExamPeriodRepairAPI('v1/school-exam-period-repair', 'SchoolExamPeriodRepair')
